/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
/**
 * The internal dependencies.
 */
import FormWrapper from '../../components/auth-form/wrapper';
import FormLink from '../../components/auth-form/link';
import FormBody from '../../components/auth-form/body';
import FormInput from '../../components/auth-form/input';
import FormLoginButton from '../../components/auth-form/button';
import {authRequestForgotPassword} from '../../store/auth/actions';

class ForgotPassword extends React.Component {
    constructor() {
        super();

        this.state = {
            email: null,
        }
    }

    submitForm = (e) => {
        e.preventDefault();

        const {email} = this.state;

        this.props.authRequestForgotPassword(email);
    };

    render() {
        return (
            <FormWrapper onSubmit={this.submitForm}>
                <FormLoginButton>Einreichen</FormLoginButton>

                <FormBody>
                    <FormInput
                        onChange={(e) => this.setState({email: e.target.value})}
                        type="email"
                        name="email"
                        placeholder="E-Mail"/>
                </FormBody>

                <FormLink to="/login">Login</FormLink>
            </FormWrapper>
        );
    }
}


export default connect(
    null, {
        authRequestForgotPassword,
    }
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/containers/forgot-password-form/index.js